import classNames from "classnames";
import { useState } from "react";

export const useSelector = ({multiple=false}={}) => {
    const [value,setValue] = useState(null);
    const handleOnChange = (e) => {
        setValue(_prevvalue => {
            if(multiple){
                if(Array.isArray(_prevvalue)){
                    const index = _prevvalue.findIndex((item) => item.value === e?.value);
                    if(index !== -1){
                        _prevvalue.splice(index,1);
                    } else {
                        _prevvalue.push(e);
                    }
                } else {
                    if(_prevvalue?.value === e?.value){
                        _prevvalue = [];
                    } else {
                        _prevvalue = [e];
                    }
                }
                return [..._prevvalue];
            } else {
                if(_prevvalue?.value === e?.value){
                    _prevvalue = null;
                } else {
                    _prevvalue = e;
                }
                return _prevvalue;
            }
        });
    };
    const reset = () => {
        setValue(null);
    }

    return {
        value,
        handleOnChange,
        reset,
        bind:{
            value:value?Array.isArray(value)?value:[value]:value,
            onChange:handleOnChange,
            multiple
        }
    }
}

export const useInputCheck = ({fnonChange}={}) => {
    const [value,setValue] = useState(null);
    const handleOnChange = () => {
        fnonChange?.(!value);
        setValue((prevvalue) => !prevvalue);
    };
    return {
        value,
        bind:{
            value,
            onChange:handleOnChange
        }
    }
}

export const InputCheck = ({ value, onChange, name,className }) => {
    const handleOnClick = () => {
        onChange({ target: { name, value: !value } });
    };
    return (
        <div className={classNames("w-[20px] h-[20px] flex justify-center items-center border-2 border-LightBlue-250 text-LightBlue-250 rounded",className)} onClick={handleOnClick}>
            {value && (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-full h-full"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 13l4 4L19 7"
                    />
                </svg>
            )}
        </div>
    );
}